<div class="ui-g ui-fluid form-group master-data customer-cards-info centered-container" style="display: contents;">
  <p-panel *ngFor="let preferedGift of preferredGiftList; index as i" class="ui-g-12 ui-md-12">
      <p-header>
          <div class="ui-helper-clearfix">
              <span class="ui-panel-title">{{ 'catalog.preferGift' | translate }}</span>
              <div class="ui-button-title">
                  <button pButton type="button" icon="fa fa-pencil" style="background-color: #0099ff;" pTooltip="{{ 'catalog.modifyPreferGift' | translate }}" (click)="showEditPreferGift(preferedGift)"></button>
                  <button pButton type="button" icon="fa fa-trash" style="background-color: #b93e3e;" pTooltip="{{ 'catalog.deletePreferGift' | translate }}" (click)="showDeletePreferGift(preferedGift)"></button>
              </div>
          </div>
      </p-header>
      <div class="ui-g-12 ui-fluid">
          <div class="ui-g-12">
              <div class="ui-g-4">
                  <label>{{ 'reservations.catalog' | translate }}:</label>
                  <span>{{preferedGift.description}}</span>
              </div>
              <div class="ui-g-4">
                  <label>{{ 'reservations.gift' | translate }}:</label>
                  <span>{{preferedGift.giftList[0].description}}</span>
              </div>
              <div class="ui-g-4">
                <label>{{ 'reservations.giftAndContribution' | translate }}:</label>
                <div style="display: contents; align-items: center;" *ngIf="preferedGift.giftList[0]?.item?.length > 0">
                    <span style="display: block; margin-bottom: 10px;">
                        <ng-container *ngIf="preferedGift.giftList[0].item[0].rdm_points && preferedGift.giftList[0].item[0].rdm_points > 0">
                            {{ preferedGift.giftList[0].item[0].rdm_points }}
                        </ng-container>
                        <ng-container *ngIf="preferedGift.giftList[0].item[0].rdm_value && preferedGift.giftList[0].item[0].rdm_value > 0">
                            + {{ preferedGift.giftList[0].item[0].rdm_value }}€
                        </ng-container>
                    </span>
                    <div style="height: 1px; width: 100%; background-color: gray;" *ngIf="preferedGift.giftList[0]?.item?.length > 0"></div>
                    <div *ngIf="preferedGift.giftList[0]?.item?.length > 1">
                        <span style="display: block; margin-top: 10px;">
                            <ng-container *ngIf="preferedGift.giftList[0].item[1].rdm_points && preferedGift.giftList[0].item[1].rdm_points > 0">
                                {{ preferedGift.giftList[0].item[1].rdm_points }}
                            </ng-container>
                            <ng-container *ngIf="preferedGift.giftList[0].item[1].rdm_value && preferedGift.giftList[0].item[1].rdm_value > 0">
                                + {{ preferedGift.giftList[0].item[1].rdm_value }}€
                            </ng-container>
                        </span>
                    </div>
                </div>
            </div>
          </div>
      </div>
  </p-panel>

  <p-panel class="ui-g-12">
      <p-header>
          <div class="ui-helper-clearfix">
              <span class="ui-panel-title">{{ 'catalog.addPreferGift' | translate }}</span>
          </div>
      </p-header>
      <div class="ui-g-12 ui-fluid">
          <div class="ui-g-12">
              <span>{{ 'catalog.addPreferGiftToCustomer' | translate }}</span>
              <br><br>
              <button pTooltip="{{ 'common.add' | translate }}" pButton type="button" class="ui-button-success" icon="fa fa-plus" (click)="showAddCatalogGiftModal()"></button>
          </div>
      </div>
  </p-panel>

  <p-dialog header="{{ 'catalog.addPreferGift' | translate }}" [(visible)]="showAddCatalogGift" [modal]="true" [draggable]="false" [resizable]="false" [width]="700">
    <div class="ui-dialog-content">

      <div class="ui-g">
        <div class="ui-g-12 ui-md-12">
          <span class="label">{{ 'catalog.selectCatalog' | translate }}</span>
          <p-dropdown
          [filter]="false"
          [options]="catalogListCombo"
          [style]="{'width':'100%' }"
          [(ngModel)]="selectedCatalog"
          (onChange)="selectCatalog($event)"
          [disabled]="catalogListCombo && catalogListCombo.length === 1">
        </p-dropdown>
        </div>
        <div class="ui-g-12">
          <span class="label">{{ 'catalog.selectionGiftFromCatalog' | translate }}</span>
          <p-dropdown
            [options]="giftsListCombo"
            [(ngModel)]="selectedGift"
            [style]="{'width':'100%' }"
            [disabled]="!selectedCatalog"
            [filter]="true">
          </p-dropdown>
        </div>
      </div>
    </div>
    <div class="ui-dialog-footer">
      <button type="button" pButton class="ui-button-success btnDelete" icon="fa fa-plus" iconPos="left" (click)="addPreferGift()" label="{{ 'common.add' | translate }}" [disabled]="!selectedCatalog || !selectedGift"></button>
      <button type="button" pButton class="ui-button-danger btnDelete" icon="fa fa-close" iconPos="left" (click)="closeAddPreferGift()" label="{{ 'common.cancel' | translate }}"></button>
    </div>
  </p-dialog>

  <!-- DELETE premio preferito -->
  <p-dialog header="{{ 'catalog.deletePreferGift' | translate }}" [(visible)]="showDeletePreferredGift" [modal]="true"
    [draggable]="false" [resizable]="false">
    <div class="ui-dialog-content">
      <div class="ui-g wanrningEdit">
        <div class="ui-g-12">
          <p>{{ 'catalog.msgConfirmDelete' | translate }}</p>
        </div>
      </div>
    </div>

    <div class="ui-dialog-footer" *ngIf="showDeletePreferredGift">
      <button type="button" pButton class="ui-button-success btnDelete" icon="fa fa-ban"
        (click)="deletePreferGift()" label="{{ 'common.yes' | translate }}"></button>
      <button type="button" pButton class="ui-button-danger btnDelete" icon="fa fa-close"
        (click)="showDeletePreferredGift = false" label="{{ 'common.no' | translate }}"></button>
    </div>
  </p-dialog>
</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/catalogo-premi/catalogo-premi.component.html